import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { debounceTime } from 'rxjs/operators';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'user';
    this.token = new Login();
  }


  all(page = 1, buscar = '', paginate = 10, filtroAvancado: any = ''){
    return this.http.get<Object[]>(this.url + '?page=' + page + '&q=' + buscar + '&paginate=' + paginate + filtroAvancado, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  search(buscar: any){
    return this.http.get<Object[]>(this.url+ '?q=' + buscar, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    }).pipe(debounceTime(5000));
  }

  criar(usuario : any) {
    return this.http.post<Object[]>(this.url, usuario, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
  
  ativar(idusuario: any){
    return this.http.get<Object[]>(this.url+ '/ativar/' + idusuario, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  alterarSenha(form){
    return this.http.post<Object[]>(this.url + '/alterar-senha', form, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  inativar(idusuario: any){
    return this.http.get<Object[]>(this.url+ '/inativar/' + idusuario, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  atualizar(p : any) {
    return this.http.put<Object[]>(this.url + '/' + p.id, p, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  searchEmail(email){
    return this.http.get<Object[]>(this.url + '/email/' + email, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  detalhar(idusuario){
    return this.http.get<Object[]>(this.url + '/' + idusuario, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
}